export enum TOKEN {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
}

export enum USER_ROLE {
  ADMIN = 'ADMIN',
  SALES = 'SALE',
  TICKETING = 'TICKETING',
  ACCOUNTING = 'ACCOUNTING',
  CONTENT = 'CONTENT',
  USER = 'USER',
  GRP = 'GRP',
  DPT = 'DPT',
}

export const REDIRECT_AFTER_LOGIN_KEY = 'redirect_after_login';

/** Partner code the identity service expects for Viet An Travel accounts. */
export const IdentityPartnerCode = 'VAA';

/** Gateway route to identity `POST /api/Authentication/refresh-token`. */
export const IdentityRefreshTokenUrl = '/identity/refresh-token';

const MillisecondsPerSecond = 1000;
const SecondsPerMinute = 60;
const MinutesPerHour = 60;
const HoursPerDay = 24;
const IdentityRefreshTokenFallbackDays = 7;
const AuthCookieExpiryBufferSeconds = 60;

/**
 * Refresh token lifetime when the server does not say: login returns no expiry for it.
 * Mirrors the identity default `JwtSettings:RefreshTokenExpirationDays` (7 days); an expired token is rejected anyway.
 */
export const IdentityRefreshTokenFallbackLifetimeMs =
  IdentityRefreshTokenFallbackDays *
  HoursPerDay *
  MinutesPerHour *
  SecondsPerMinute *
  MillisecondsPerSecond;

/** Cookies expire this much earlier than the token, so a request never carries a token about to be rejected. */
export const AuthCookieExpiryBufferMs =
  AuthCookieExpiryBufferSeconds * MillisecondsPerSecond;
